import React, { createContext, useContext, useRef } from 'react';
import { Toast } from 'primereact/toast';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const toast = useRef(null);

  const showError = (summary, detail = '') => {
    toast.current.show({
      severity: 'error',
      summary: summary,
      detail: detail,
      life: 5000
    });
  };

  const showSuccess = (summary, detail = '') => {
    toast.current.show({
      severity: 'success',
      summary: summary,
      detail: detail,
      life: 3000
    });
  };

  const showInfo = (summary, detail = '') => {
    toast.current.show({
      severity: 'info',
      summary: summary,
      detail: detail,
      life: 3000
    });
  };

  return (
    <ToastContext.Provider value={{ showError, showSuccess, showInfo }}>
      <Toast ref={toast} position="top-right" />
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
